import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import "./App.css";
/* FRONTEND */
import MainLayout from "./layout/Mainlayout";
import Home from "./pages/Home";
import GamesPage from "./pages/GamesPage";
import TrailerPage from "./pages/TrailerPage";
import SignIn from "./pages/auth/SignIn";
import Blog from "./pages/Blog";
import VideoPage from "./pages/VideoPage";
import MyAccount from "./pages/MyAccount";
import Wallet from "./pages/Wallet";
import LeaderboardPage from "./pages/LeaderboardPage";
import Play from "./pages/Play";
import NotFound from "./pages/NotFound";
import Support  from "./pages/Support";
import Tournament from "pages/Tournament";
import Gameiosign from "pages/auth/Gameiosign";
import ActivationCallback from "./pages/ActivationCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import SubscriptionRoute from "./components/SubscriptionRoute";
import Loading from "./pages/Loading";
import AfterHE from "./pages/AfterHE";
import GmmPage from "./pages/GmmPage";
/* 🔥 ADMIN – LAZY LOADED */
const Admin = lazy(() => import("./admin/Admin"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
     <Route path="/gmm/index" element={<GmmPage />} />
               <Route path="/loading" element={<Loading />} />
               <Route path="/after-he" element={<AfterHE />} />
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="games" element={<GamesPage />} />
            
         <Route path="play" element={
  <SubscriptionRoute>
    <Play />
  </SubscriptionRoute>
} />
         
          <Route path="news" element={<TrailerPage />} />
          <Route path="signin" element={<SignIn />} />
          <Route path="blog" element={<Blog />} />
          <Route path="video" element={<VideoPage />} />
          <Route path="support" element={<Support />} />
          <Route path="Tournament" element={<Tournament />} />
            
         <Route path="myaccount" element={<MyAccount />} />
           
          <Route path="wallet" element={<Wallet />} />
            
         <Route path="leaderboard" element={
  <ProtectedRoute>
    <LeaderboardPage />
  </ProtectedRoute>
} />
          <Route path="activation/callback" element={<ActivationCallback />} />
          <Route path="*" element={<NotFound />} />
        </Route>

         <Route path="Gameiosign" element={<Gameiosign />} />
        
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div>Loading admin...</div>}>
              <Admin />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
